const MobileNav = {
  _selectors: {
    navTrigger: '.js-mobile-nav-trigger',
    mobileNav: '.desktop-nav',
    mobileMenu: '.js-nav-menu',
    submenuTrigger: '.js-mobile-submenu-trigger',
    submenu: '.js-nav-menu-dropdown'
  },

  init() {
    this._bindNavToggle();
    this._bindSubmenuDelegation();
  },

  _bindNavToggle() {
    const btn = document.querySelector(this._selectors.navTrigger);
    if (!btn) return;
    btn.addEventListener('click', () => this.toggleMobileNav());
  },

  _bindSubmenuDelegation() {
    const menu = document.querySelector(this._selectors.mobileMenu);
    if (!menu) return;

    menu.addEventListener('click', (e) => {
      const trigger = e.target.closest(this._selectors.submenuTrigger);
      const link = e.target.closest('.nav-menu > .nav-menu-item > a');
      if (link && !link.closest('.nav-menu-item--has-children')) {
        const nav = document.querySelector(this._selectors.mobileNav);
        const btn = document.querySelector(this._selectors.navTrigger);
        if (nav) nav.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        if (btn) btn.classList.remove('hamburger--active');
        return;
      }
      if (!trigger || !menu.contains(trigger)) return;

      const nav = document.querySelector(this._selectors.mobileNav);
      if (window.innerWidth <= 767 && nav.classList.contains('is-open')) {
        this.toggleSubmenu(trigger);
      }
    });
  },

  toggleMobileNav() {
    const btn = document.querySelector(this._selectors.navTrigger);
    const nav = document.querySelector(this._selectors.mobileNav);
    const body = document.body;

    if (btn) btn.classList.toggle('hamburger--active');
    if (!nav) return;

    nav.classList.toggle('is-open');
    body.classList.toggle('no-scroll');
  },

  toggleSubmenu(trigger) {
    if (trigger.classList.contains('has-submenu-open')) {
      this.closeSubmenu(trigger);
    } else {
      // only close submenus at this same level
      const parent = trigger.parentNode;
      const openSiblings = Array.from(parent.children)
        .filter(el =>
          el !== trigger && el.classList.contains('has-submenu-open')
        );
      openSiblings.forEach(sib => this.closeSubmenu(sib));

      this.openSubmenu(trigger);
    }
  },

  openSubmenu(trigger) {
    const dropdown = trigger.querySelector(this._selectors.submenu);
    if (!dropdown) return;

    // start from zero so transition runs
    dropdown.style.height = '0px';
    trigger.classList.add('has-submenu-open');

    requestAnimationFrame(() => {
      dropdown.style.height = `${dropdown.scrollHeight}px`;
    });

    dropdown.addEventListener('transitionend', () => {
      // once open, let it size naturally
      dropdown.style.height = 'auto';
    }, { once: true });
  },

  closeSubmenu(trigger) {
    const dropdown = trigger.querySelector(this._selectors.submenu);
    if (!dropdown) return;

    // force from auto -> px so transition works
    dropdown.style.height = `${dropdown.scrollHeight}px`;

    requestAnimationFrame(() => {
      dropdown.style.height = '0px';
    });

    trigger.classList.remove('has-submenu-open');

    dropdown.addEventListener('transitionend', () => {
      // clean up inline height so re-opening works
      dropdown.style.height = '';
    }, { once: true });
  }
};

export default MobileNav;